import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/CartViewer';

const getListProductReducer = handleActions({
    [Actions.getListProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getListProductReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getListProductReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload,
    }),
    [Actions.clearListProduct]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getListHistoryOrderReducer = handleActions({
    [Actions.getListHistoryOrderRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getListHistoryOrderReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getListHistoryOrderReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload,
    }),
    [Actions.clearListHistoryOrder]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getDetailHistoryProductReducer = handleActions({
    [Actions.getDetailHistoryProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getDetailHistoryProductReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getDetailHistoryProductReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload,
    }),
    [Actions.clearDetailHistoryProduct]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const UserProfileReducer = handleActions({
    [Actions.getUserProfileRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getUserProfileReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getUserProfileReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearGetUserProfile]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const deleteProductReducer = handleActions({
    [Actions.deleteProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.deleteProductReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
        isErrors: false,
    }),
    [Actions.deleteProductReceivedFailure]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        isErrors: true,
    }),
    [Actions.clearDeleteProduct]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        isErrors: false,
    }),
}, {
    isFetching: false,
    isSuccess: false,
    isErrors: false,
});

const changeQuantityProductReducer = handleActions({
    [Actions.changeQuantityProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.changeQuantityProductReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.changeQuantityProductReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearChangeQuantity]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const orderProductReducer = handleActions({
    [Actions.orderProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.orderProductReceived]: (state) => ({
        ...state,
        isFetching: false,
        success: true,
    }),
    [Actions.orderProductReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: action.payload.errors,
    }),
    [Actions.clearOrderProduct]: (state) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: {},
    }),
}, {
    isFetching: false,
    success: false,
    errors: {},
});

const getCountProductReducer = handleActions({
    [Actions.getCountProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getCountProductReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getCountProductReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearCountProduct]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

export default combineReducers({
    getListProduct: getListProductReducer,
    getListHistoryOrder: getListHistoryOrderReducer,
    getDetailHistoryProduct: getDetailHistoryProductReducer,
    userProfile: UserProfileReducer,
    deleteProduct: deleteProductReducer,
    changeQuantityProduct: changeQuantityProductReducer,
    orderProduct: orderProductReducer,
    count: getCountProductReducer,
});
